<h3>{{ 'admin.temoi.titre' | traduire }}
  <span class="badge-notif" *ngIf="nombreEnAttente > 0">{{ nombreEnAttente }}</span>
</h3>
<p class="astuce-section">
  {{ 'admin.temoi.explication' | traduire }}
  <br>{{ 'admin.temoi.explicationAvis' | traduire }}
</p>

<button type="button" class="btn-ajouter" *ngIf="!formulaireOuvert" (click)="formulaireOuvert = true">
  {{ 'admin.temoi.ajouterBtn' | traduire }}
</button>

<form class="form-ajout-temoi" *ngIf="formulaireOuvert" (ngSubmit)="ajouterManuel()">
  <div class="ligne">
    <div>
      <label>{{ 'admin.temoi.auteur' | traduire }}</label>
      <input type="text" [(ngModel)]="nouveauTemoignage.auteur" name="auteur" required>
    </div>
    <div>
      <label>{{ 'admin.temoi.ville' | traduire }}</label>
      <input type="text" [(ngModel)]="nouveauTemoignage.lieu" name="lieu" required>
    </div>
  </div>
  <label>{{ 'admin.temoi.note' | traduire }}</label>
  <div class="etoiles-choix">
    <span *ngFor="let n of [1,2,3,4,5]" [class.pleine]="n <= nouveauTemoignage.note" (click)="nouveauTemoignage.note = n">★</span>
  </div>
  <label>{{ 'admin.temoi.citation' | traduire }}</label>
  <textarea [(ngModel)]="nouveauTemoignage.contenu" name="contenu" rows="3" required></textarea>
  <div class="form-actions">
    <button type="submit">{{ 'admin.temoi.publier' | traduire }}</button>
    <button type="button" class="btn-annuler" (click)="formulaireOuvert = false">{{ 'admin.recl.annuler' | traduire }}</button>
  </div>
</form>

<div class="filtre-barre">
  <select [(ngModel)]="filtreStatut">
    <option value="">{{ 'admin.temoi.tousStatuts' | traduire }}</option>
    <option value="attente">{{ 'admin.temoi.enAttente' | traduire }}</option>
    <option value="approuve">{{ 'admin.temoi.approuve' | traduire }}</option>
    <option value="rejete">{{ 'admin.temoi.rejete' | traduire }}</option>
  </select>
</div>

<div class="temoignage-liste">
  <div class="temoignage-carte" *ngFor="let t of temoignagesFiltres">
    <div class="temoignage-contenu">
      <div class="etoiles">{{ etoiles(t.note) }}</div>
      <p class="citation">« {{ t.contenu }} »</p>
      <p class="auteur">{{ t.auteur }} — {{ t.lieu }}
        <span class="badge" [ngClass]="t.statut">
          {{ t.statut === 'attente' ? ('admin.temoi.enAttente' | traduire) : t.statut === 'approuve' ? ('admin.temoi.approuve' | traduire) : ('admin.temoi.rejete' | traduire) }}
        </span>
      </p>
    </div>
    <div class="temoignage-actions">
      <button class="btn-approuver" (click)="approuver(t)">{{ 'admin.temoi.approuverBtn' | traduire }}</button>
      <button class="btn-rejeter" (click)="rejeter(t)">{{ 'admin.temoi.rejeterBtn' | traduire }}</button>
      <button class="btn-supprimer" (click)="supprimer(t)">{{ 'admin.recl.supprimer' | traduire }}</button>
    </div>
  </div>

  <p *ngIf="temoignagesFiltres.length === 0" style="color:#888;">{{ 'admin.temoi.vide' | traduire }}</p>
</div>
